export default __webpack_public_path__ + "static/media/correto_branco.d80b0ab7.svg";